// mega menu

var $menu = $('.mega-menu'),
    $menuMainItem = $('.mm-main-item'),
    $menuMainItemWantToMenu = $('.i-want-to .mm-main-item'),
    $menuSubItem = $('.mm-sub-item'),
    $MegaMenuWantToSubItem = $('.mega-menu.i-want-to .mm-sub-item'),
    $MegaMenuWantToThirdSubItem = $('.mega-menu.i-want-to .mm-sub-item.third-item'),
    $menuSubItemChild =('.mm-sub-item:first-child'),
    $menuActionItem = $('.mm-action-item'),
    $megaMenuWantToHeight = $('.mega-menu.i-want-to').height(),
    $megaMenuWantToClass = $('.mega-menu.i-want-to'),
    $iWantToPage = $('.i-want-to'),
    $icon = "<span class='icon icon-arrow-right-gray'></span>";

$('.mm-main-item.parent').on('keypress click', function(e) {
  if (e.which === 13 || e.type === 'click') {
    $(this).closest($menu).addClass('active');
    }
});

$menuMainItem.on('keypress click', function(e) {
// Click on an active link to close it all up
  if (e.which === 13 || e.type === 'click') {
      if($(this).hasClass('active')) {
        $(this).closest($menu).removeClass('active');
        $(this).closest($menuMainItem).removeClass('active');
        $(this).children($menuSubItem).removeClass('active');
        // e.preventDefault();
      } else {
        // close other drawers
        $(this).closest($menu).find($menuMainItem).removeClass('active');
        // open this drawer
        $(this).addClass('active');
        // open its first action item
        $(this).closest($menu).find($menuSubItem).removeClass('active');
        e.preventDefault();
      }
  }
});

$('header .mm-sub-item').on('keypress click', function(e) {
  if (e.which === 13 || e.type === 'click') {
        e.stopPropagation();
        if ( $(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).closest($menu).find($menuSubItem).removeClass('active');
            $(this).addClass('active');
        }
    }

});

$('article .mm-sub-item').on('keypress click', function(e) {
  if (e.which === 13 || e.type === 'click') {
      e.stopPropagation();
      // close other drawers
      if($(this).hasClass('third-item') ){
          $(this).parent().find($menuSubItem).removeClass('active');
          $(this).parent().addClass('display-active');
      }  else  {
          $menuSubItem.removeClass('active');
      }
      // open this drawer
      $(this).addClass('active');
      $(this).closest($menuMainItem).addClass('hide-child');

      if ( $('.third-item').hasClass('active') ) {
          var currentSubText = $('article .third-item.active').find('> span').text();
          $('.current-progress .current-secondary-subtitle').addClass('display');
          $('.current-progress .current-secondary-subtitle').html(currentSubText + $icon);
      } else {
          // adding current position of question to top section of page
          var currentSubItem = $('article .mm-sub-item.active').find('> span').text();
          $('.current-progress .current-subtitle').addClass('display');
          $('.current-progress .current-subtitle').html(currentSubItem + $icon);
          $('.current-progress .current-secondary-subtitle').text('');
      }
  }
});

$(document).ready(function(e) {
    var url = window.location;

    $('a[href="'+url+'"]').addClass('active-page');
    $('a[href="'+url+'"]').closest('.mm-main-item-single').addClass('active-page');
});

// clicking on the first menu item and changing size of screen based off child elements
$menuMainItemWantToMenu.on('keypress click', function(e) {
  if (e.which === 13 || e.type === 'click') {

        if ($(this).hasClass('active')) {
            var $menuChildHeight = $(this).find('.mm-sub-items').outerHeight(true),
                maxHeight = 0;

            $(this).find('ul').each(function(){
                var currentHeight = $(this).outerHeight();
                 maxHeight = currentHeight > maxHeight ? currentHeight : maxHeight;
            });
            var setHeight = parseInt(maxHeight) + $megaMenuWantToHeight;
            $('.mega-menu.i-want-to.active').css({"height": setHeight + "px"});
        }   else {
                $megaMenuWantToClass.css({"height": $megaMenuWantToHeight + "px"});
        }
    }
});

// clicking on the sub menu items and adjusting height on menu container to fit
$MegaMenuWantToSubItem.on('keypress click', function(e) {
  if (e.which === 13 || e.type === 'click') {

        if ($(this).hasClass('active')) {
            var $menuChildHeight = $(this).find('.mm-sub-items').outerHeight(true),
                $parentsHeight = $(this).parent().outerHeight(true),
                maxHeight = 0;

            $(this).parents('.mm-main-item.active').find('ul').each(function(){
                var currentHeight = $(this).is(':visible') ? $(this).outerHeight(true) : 0;
                 maxHeight = currentHeight > maxHeight ? currentHeight : maxHeight;
            });
            var setHeight = parseInt(maxHeight) + $megaMenuWantToHeight;
            $('.mega-menu.i-want-to.active').css({"height": setHeight + "px"});
        }   else {
                $megaMenuWantToClass.css({"height": $megaMenuWantToHeight + "px"});
        }
    }
});

if ($iWantToPage.length) {


    window.onhashchange = function() {

        //fixing bugs by removing classes that would have been added if page wasnt refreshed
        $('.current-progress .current-secondary-subtitle').text('');
        $('.current-progress .current-subtitle').text('');
        $('.mm-main-item').removeClass('hide-child');
        $('.mm-sub-items.display-active').removeClass('display-active');

        jQuery.expr[':'].Contains = function(a, i, m) {
         return jQuery(a).text().toUpperCase()
             .indexOf(m[3].toUpperCase()) >= 0;
        };
        var $hashOrig = window.location.hash.replace('#','').toUpperCase(),
            $typeOrig = window.location.hash.substr(1).toUpperCase(),
            $hash = decodeURIComponent($hashOrig),
            $type = decodeURIComponent($typeOrig);

        if ($hash === $('.i-want-to .mm-main-item.parent > span:Contains(' + $type + ')').text().toUpperCase() ) {
            var $hashClass = $('.i-want-to .mm-main-item.parent > span:Contains(' + $type + ')');
            $hashClass.parent().trigger("click");
        }
    }

    $(function() {

        $('article .mega-menu').on('keypress click', function(e) {
          if (e.which === 13 || e.type === 'click') {

                if ( $menu.hasClass('active')) {
                    $('.current-progress').addClass('active');
                } else {
                    $('.current-progress').removeClass('active');
                }

                if ( $menuMainItem.hasClass('active') && !$menuMainItem.hasClass('.third-item') ) {
                    var currentItem = $('article.i-want-to .mm-main-item.active').find('> span').text();
                    $('.current-progress .current-title').addClass('display');
                    $('.current-progress .current-title').text(currentItem);
                }
        }
        });

        jQuery.expr[':'].Contains = function(a, i, m) {
         return jQuery(a).text().toUpperCase()
             .indexOf(m[3].toUpperCase()) >= 0;
        };

        var $hashOrig = window.location.hash.replace('#','').toUpperCase(),
            $typeOrig = window.location.hash.substr(1).toUpperCase(),
            $hash = decodeURIComponent($hashOrig),
            $type = decodeURIComponent($typeOrig);

        if ($hash === $('.i-want-to .mm-main-item.parent > span:Contains(' + $type + ')').text().toUpperCase() ) {
            var $hashClass = $('.i-want-to .mm-main-item.parent > span:Contains(' + $type + ')');
            $hashClass.parent().trigger("click");
        }

    });
}

$('.icon-con.back-to-button').on('keypress click', function(e) {
  if (e.which === 13 || e.type === 'click') {
        if ( $('.mm-main-item').hasClass('active') && !$('.mm-main-item > .mm-sub-items > .mm-sub-item').hasClass('active') ) {
            $('.mm-main-item').removeClass('active');
            $('article .mega-menu.i-want-to').removeClass('active');
            $('.current-progress .current-title').text('');
            $('.current-progress').removeClass('active');
        }

        if ( $('.mm-main-item > .mm-sub-items > .mm-sub-item').hasClass('active') && !$('.mm-sub-item.third-item').hasClass('active') ) {
            $('.mm-sub-item').removeClass('active');
            $('.mm-main-item').removeClass('hide-child');
            $('.current-progress .current-subtitle').text('');
        }

        if ( $('.mm-sub-item.third-item').hasClass('active') ) {
            $('.mm-sub-item.third-item').removeClass('active');
            $('.mm-sub-items.display-active').removeClass('display-active');
            $('.current-progress .current-secondary-subtitle').text('');
        }
    }
});



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_mega-menu.js